export const PHONE_LAST_DIGITS_COUNT_TO_EXTRACT = 3;
export const extractFullPhoneNumber = (phone) => phone.replace(/[^\d]+/g, '');
export const getPhoneLastDigits = (phone) => phone?.slice(-PHONE_LAST_DIGITS_COUNT_TO_EXTRACT) || '';
export const phoneNumberAutoFormat = (phoneNumber) => {
    const number = phoneNumber.trim().replace(/[^0-9]/g, '');
    if (number.length < 4)
        return number;
    if (number.length < 7)
        return number.replace(/(\d{3})(\d{1})/, '$1-$2');
    if (number.length < 11)
        return number.replace(/(\d{3})(\d{3})(\d{1})/, '$1-$2-$3');
    return number.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
};
//# sourceMappingURL=phone.js.map